import * as Factory from 'factory.ts'

import { Permissions } from '@webapp/platform/iam'
import { type ExportDataTypeConfig } from './ExportDataTypeConfig'
import { ExportTypes } from '../enums/ExportTypeEnum'

// Plain-interface value object — single Factory.Sync.makeFactory, no
// EntityFactory/ConstructorFactory pair (no class constructor).
export const ExportDataTypeConfigFactory =
  Factory.Sync.makeFactory<ExportDataTypeConfig>({
    key: Factory.each((i) => `export_type_${i}`),
    type: ExportTypes.BILLS,
    apiEndpointBase: '/api/v2/ap/bills',
    permission: Permissions.SETTINGS_EXPORT_DATA_BILL,
    visibility: {},
    showFormat: true,
    filters: [],
    pendoKey: 'export-bills',
  })
